import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import SelectOption, { RadioItem } from "./../SelectOption";
import MgGlass from "../MagnifyingGlass";
import CountdownTimer from "../CountDownTime";
import Search from "./../../assets/images/generic/searchblue.png";
import sanitizeHtml from "sanitize-html";
import { Parser } from "html-to-react";
import { CardQuestion } from "../../types/Types";
import { GameDetails } from "../../types/Game";
import GenericUtil from "./../../util/Generic";

export type BlueCardProps = {
  title: string;
  subTitle: string;
  body: string;
  hint: string;
  hiddenAnswer: string | null;
  wrongAnswerLabel: string;
  rightAnswerLabel: string;
  rightAnswerValue: string;
  sendAnswerLabel: string;
  continuePlayingLabel: string;
  hintLabel: string;
  timeOut: number;
  magnifyingGlasses: number;
};

type Props = {
  data: BlueCardProps;
  questions: CardQuestion[];
  onTimeOut: () => void;
  onCardAnswer: (answer: string, isRight: boolean) => void;
  onUseMagnifyingGlass: () => void;
  isUsersTurn: boolean;
  game: GameDetails;
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
}

export default function RedCard(props: Props) {
  const { data, questions } = props;
  const [open, setOpen] = React.useState(false);
  const [answer, setAnswer] = React.useState("");
  const [isAnswerSent, setIsAnswerSent] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    console.log("Blue card has rendered:", data);
    setOpen(true);
  }, [data]);

  const onChange = (value: string) => {
    console.log("Answer:", value);
    setAnswer(value);
  };

  const isRightAnswer = () => {
    console.log("User answer:", props.game.cardAnswer);
    console.log("Card conrtent:", props.data);
    return GenericUtil.compareStringsIgnoreCaseAndTrim(
      props.game.cardAnswer || "",
      props.data.rightAnswerValue
    );
  };

  const getAnswerStatus = () => {
    const res = isRightAnswer() ? "success" : "error";
    return res;
  };

  const getAnswerLabel = () => {
    const res = isRightAnswer()
      ? props.data.rightAnswerLabel
      : props.data.wrongAnswerLabel;
    return res;
  };

  const onCardAnswer = () => {
    const isRight = GenericUtil.compareStringsIgnoreCaseAndTrim(
      answer,
      props.data.rightAnswerValue
    );

    props.onCardAnswer(answer, isRight);
    setIsAnswerSent(true);
  };

  return (
    <Box>
      <BootstrapDialog
        className="titleDialogBlue dialogContainer"
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title">
          {data.title}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom className="introTextDialog">
            {Parser().parse(sanitizeHtml(data.subTitle))}
          </Typography>

          <SelectOption
            value={props.game.cardAnswer}
            onChange={onChange}
            defaultValue="verdadero"
            disabled={!props.isUsersTurn || isAnswerSent}
            options={questions}
          />
          {props.game.cardAnswer && (
            <Alert severity={getAnswerStatus()}>{getAnswerLabel()}</Alert>
          )}
          {props.isUsersTurn && answer && !isAnswerSent && (
            <div className="areaButtonTextDialog">
              <Button
                onClick={onCardAnswer}
                className="buttonTextDialog"
                variant="contained"
              >
                {data.sendAnswerLabel}
              </Button>
            </div>
          )}
          {data.hiddenAnswer &&
            props.isUsersTurn &&
            !isAnswerSent &&
            props.data.magnifyingGlasses > 0 && (
              <MgGlass
                onUseMagnifyingGlass={props.onUseMagnifyingGlass}
                hint={data.hiddenAnswer}
                search={Search}
              />
            )}
          <CountdownTimer
            time={props.data.timeOut}
            onTimeOut={props.onTimeOut}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>
    </Box>
  );
}
